interface HeaderProps {
  user: {
    username: string;
    profile_pic_url: string | null;
  } | null;
  theme: "light" | "dark";
  onToggleTheme: () => void;
}

export function Header({ user, theme, onToggleTheme }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-main">
        <div className="header-title-section">
          <h1 className="site-title">Borges Ink</h1>
          <p className="site-tagline">"this is just like a Borges story!"</p>
        </div>
        <div className="header-user">
          <button
            className="theme-toggle"
            onClick={onToggleTheme}
            title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
          >
            {theme === "light" ? "☾" : "☀"}
          </button>
          {user ? (
            <div className="user-info">
              {user.profile_pic_url && (
                <img
                  src={user.profile_pic_url}
                  alt={user.username}
                  className="user-avatar"
                />
              )}
              <span className="username">@{user.username}</span>
              <a href="/auth/logout" className="logout-link">
                logout
              </a>
            </div>
          ) : (
            <a href="/auth/login" className="login-btn">
              Login with X
            </a>
          )}
        </div>
      </div>
      <hr className="header-rule" />
    </header>
  );
}
